import React  from 'react';
import ListComponentProto from './rating-proto.jsx';


export default function renderListInView(id, props) {
    return <ListComponentProto renderMode="edit" id={id} {...props} />;
}